import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonModule } from '../button';
import { ScrollbarModule } from '../scrollbar/scrollbar.module';
import { SmartbarModule } from '../smartbar/smartbar.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

import { LeftCardContentComponent } from './left-card-content/left-card-content.component';
import { LeftCardComponent } from './left-card.component';

@NgModule({
  declarations: [LeftCardComponent, LeftCardContentComponent],
  imports: [CommonModule, ButtonModule, SvgIconModule, SmartbarModule, ScrollbarModule],
  exports: [LeftCardComponent, LeftCardContentComponent]
})
export class LeftCardModule {}

export * from './left-card-content/left-card-content.component';
export * from './left-card.component';
